export default __webpack_public_path__ + "static/media/attachment.1f586925.svg";